import axios from 'axios';
import { apiDomain } from '@/config';
import * as types from './types';

const actions = {
  reset: ({ commit }) => {
    commit(types.RESET);
  },
  async initialLoading({ commit, dispatch }, payload) {
    commit(types.INITIAL_LOADING_PENDING);
    try {
      await Promise.all([
        dispatch('fetchApplications', payload),
        dispatch('company/jobs/fetchJobs', { companyId: payload.companyId, listType: 'active' }, { root: true }),
      ]);
      commit(types.INITIAL_LOADING_FULFILLED);
      return true;
    } catch (error) {
      commit(types.INITIAL_LOADING_ERROR);
      return Promise.reject(error);
    }
  },
  async fetchApplications({ commit }, payload) {
    commit(types.FETCH_APPLICATIONS_PENDING);
    try {
      const url = `${apiDomain}company/${payload.companyId}/applications?scope=${payload.listType}`;
      const response = await axios.get(url);
      commit(types.FETCH_APPLICATIONS_FULFILLED, response);
      return true;
    } catch (error) {
      commit(types.FETCH_APPLICATIONS_ERROR);
      return Promise.reject(error);
    }
  },
  async updateApplication({ commit, dispatch }, payload) {
    commit(types.UPDATE_APPLICATION_PENDING);
    try {
      const url = `${apiDomain}company/${payload.companyId}/applications/${payload.id}`;
      const response = await axios.patch(url, payload.values);
      dispatch('fetchApplications', { companyId: payload.companyId, listType: 'open' });
      commit(types.UPDATE_APPLICATION_FULFILLED, response);
      dispatch('messages/showMessage', { key: 'alert.updateJobApplicationStatusSuccessful', color: 'success' }, { root: true });
      return true;
    } catch (error) {
      commit(types.UPDATE_APPLICATION_ERROR);
      dispatch('messages/showMessage', { key: 'alert.updateJobApplicationStatusError', color: 'error' }, { root: true });
      return Promise.reject(error);
    }
  },
};

export default actions;
